import {IEnvironment} from './IEnvironment';

export const environment: IEnvironment = {
  production: false,
  dev: true,
  // auth: {
  //   clientId: '7779e19c-dbe7-4bc2-9c15-a6052a9d0622',
  //   authority: 'https://login.microsoftonline.com/3bd97919-57c3-48d3-9e9a-8e4c01614a8f',
  //   redirectUri: 'https://p.finops.automotive.cloud/',
  //   postLogoutRedirectUri: '/'
  // },
  //  apiUri: 'https://api.p.finops.automotive.cloud'
    auth: {
    clientId: '7779e19c-dbe7-4bc2-9c15-a6052a9d0622',
    authority: 'https://login.microsoftonline.com/3bd97919-57c3-48d3-9e9a-8e4c01614a8f',
    redirectUri: 'https://d.finops.automotive.cloud/',
    postLogoutRedirectUri: '/'
  },
  // apiUri: 'https://api.p.finops.automotive.cloud'
   apiUri: 'https://api.d.finops.automotive.cloud'
};
